import projectNadlanComponent from './project-nadlan.component';

const projectNadlanModule = angular.module('projectNadlan', [])
  .component('projectNadlan', projectNadlanComponent)
  .name;

export default projectNadlanModule;
